import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import HeadingCover from "../../../components/text/heading-cover/heading-cover"
import CardsCarousel from "../../../components/cards-carousel/cards-carousel"
import Heading from "../../../components/text/heading/heading"
import BodyText from "../../../components/text/body-text/body-text"
import MapMarker from "../../../components/MapMarker/MapMarker"
import Button from "../../../components/button/button"
import { SkillInstituteCards } from "../SkillInstituteCards"
import { navigate } from "gatsby"
import { NAV_LINKS } from "../../../components/Header/nav-links"

export const SkillInstitutesLocation = () => {
  return (
    <>
      <HeadingCover className="px-4 text-center mb-8 mx-auto">
      <span>75+</span> Skill Institutes In <span>20 States</span>
      <div className="container mx-auto mt-6">
        <SkillInstituteCards />
      </div>
      </HeadingCover>
      <div id="skillInstitutes" className="max-w-[1300px] mx-auto">
        <MapMarker />
      </div>
      <div className="text-center mt-8 mx-auto">
        <Button className="mb-0" onClick={()=>{
          navigate(NAV_LINKS.LEARNET_INSTITUTE)
        }}>Know More</Button>
      </div>
    </>
  )
}
